import styled from 'styled-components';

export const Container = styled.menu`
  display: flex;
  gap: 10px;
`;
